/** @format */

import React from 'react';
import { ListedLeadsTable } from '../components/ListedLeadsTable';
import { useListedLeads } from '../hooks/useListedLeads';
import { ListedLeadFilterInput } from '../types/listedLeads.types';

interface ListedLeadsTableContainerProps {
  filter?: ListedLeadFilterInput;
}

/**
 * Container for ListedLeadsTable
 * Handles data fetching and provides callbacks for table interactions
 */
export const ListedLeadsTableContainer: React.FC<ListedLeadsTableContainerProps> = ({ filter }) => {
  const { listedLeads, loading, error, refetch } = useListedLeads(filter);

  const handleEditComplete = async () => {
    await refetch();
  };

  return (
    <ListedLeadsTable
      listedLeads={listedLeads}
      loading={loading}
      onRefresh={refetch}
      onEditComplete={handleEditComplete}
      filter={filter}
    />
  );
};

export default ListedLeadsTableContainer;
